export default __webpack_public_path__ + "static/media/Redux Shop (1).fba1a872.png";